import { graphql } from "@/graphql/generated";
import { MunicipalPropertyRegisterContentQuery, MunicipalPropertyRegisterContentQueryVariables } from "@/graphql/generated/graphql";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";

export const MUNICIPAL_PROPERTY_YEAR_LIST_QUERY_DOCUMENT: TypedDocumentNode<MunicipalPropertyRegisterContentQuery, MunicipalPropertyRegisterContentQueryVariables> = graphql(/* GraphQL */ `
    query MunicipalPropertyRegisterContent($registerId: ID!, $inventoryId: ID, $first: Int, $after: ID, $contribution: MunicipalPropertyContributionFilter) {
      municipalPropertyYearList(registerId: $registerId, inventoryId: $inventoryId, first: $first, after: $after, contribution: $contribution) {
        endCursor
        hasNextPage
        nodeList {
          id
          registerId
          propertyId
          name
          contributionAmount
          contributionDataSource
        year
        effectiveYear
        municipalityId
        municipalityName
          type
        }
      }
    }
  `);
